export default __webpack_public_path__ + "static/media/liveFeedTime.3f765861.png";